module.exports = __webpack_public_path__ + "media/images/captive_portal/template3-b3d7e7f4c4fe11efdd4ea74c06bfc965.png";